module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "preface",
    attrs: {
      "id": "ada"
    }
  }, [_c('h1', {
    staticClass: "subchapter"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780865477377_ada.png"
    }
  }), _c('br'), _c('em', [_vm._v("Tom Lutz")])]), _vm._v(" "), _c('h1', {
    staticClass: "subchapter"
  }, [_vm._v("DOING NOTHING")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Tom Lutz is the author of "), _c('em', [_vm._v("Crying: The Natural and Cultural History of Tears")]), _vm._v(", which "), _c('em', [_vm._v("The Washington Post")]), _vm._v(" called “a tour de force of erudition.” His other books include "), _c('em', [_vm._v("American Nervousness, 1903: An Anecdotal History")]), _vm._v(" and "), _c('em', [_vm._v("Cosmopolitan Vistas: American Regionalism and Literary Value.")]), _vm._v(" He lives in Los Angeles.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c03c1fba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780865477377_epub_ada_r1.vue
// module id = 57
// module chunks = 0